import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/credit-reports-b2c/{creditReportId}']['PUT'];

type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const updateCreditReport = async ({ creditReportId, ...body }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/credit-reports-b2c/{creditReportId}', { creditReportId });
  const response = await noodleApiClient.put(path, body);
  return response.data;
};

export default updateCreditReport;
